import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastService } from 'ng-uikit-pro-standard';
import { EstadoMaquinaService } from 'src/app/services/estado-maquina.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { TipoDestinatarioService } from 'src/app/services/tipo-destinatario.service';
import { MaquinaService } from 'src/app/services/maquina.service';
import * as _ from 'lodash'
import { FileDownloadService } from 'src/app/shared/services/file-download.service';

@Component({
  selector: 'app-maquinas-reporte-ubicacion',
  templateUrl: './maquinas-reporte-ubicacion.component.html',
  styleUrls: ['./maquinas-reporte-ubicacion.component.scss'],
  providers: [SecurityService]
})
export class MaquinasReporteUbicacionComponent implements OnInit {

  optionsUbicacion: Array<any> = [];
  optionsEstado: Array<any> = [];

  formHeader: FormGroup;

  // Data & Tmp
  public rutEmpresa: number
  public sucursalCodigo: number
  loading: boolean = false
  listaMaquinas: Array<any> = null
  paginationContext: PaginationContext = new PaginationContext()
  currentPayload: any

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private messageRendererService: MessageRendererService,
    private clog: ConsoleService,
    private toastService: ToastService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private rutService: RutService,
    private estadoMaquinaService: EstadoMaquinaService,
    private tipoDestinatarioService: TipoDestinatarioService,
    private maquinaService: MaquinaService,
    private fileDownloadService: FileDownloadService,
  ) {
    this.log = this.clog.log('MAQUINAS')
  }


  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.paginationContext.RecordsByPage = 10

    this.loadUbicacion()
    this.loadEstados()

    this.createForms()
  }

  loadUbicacion() {
    this.tipoDestinatarioService.obtenerTodos(({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      const { registros } = respuesta
      this.optionsUbicacion = registros.map(p => ({ value: p.codigo, label: p.nombre, ...p }))
    })
  }

  loadEstados() {
    this.estadoMaquinaService.obtenerTodos(({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      const { registros } = respuesta
      this.optionsEstado = registros.map(p => ({ value: p.codigo, label: p.nombre, ...p }))
    })
  }

  private createForms() {
    this.formHeader = this.fb.group({
      ubicacion: [[], [Validators.required]],
      estado: [[], [Validators.required]],
      incluirClientesSinVentas: [[], [Validators.required]],
    });
  }

  buscar(pageNumber: number) {
    // this.formValidatorsService.validateAllFormFields(this.formHeader)
    // if (!this.formHeader.valid)
    //   return

    this.paginationContext.CurrentPage = pageNumber

    this.listaMaquinas = null

    const inputParams = {
      ubicacion: this.formHeader.get('ubicacion').value,
      estado: this.formHeader.get('estado').value,
      filtro: {
        exacto: {
          empresa_rut: this.rutEmpresa
        }
      },
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage
    }
    this.currentPayload = inputParams

    this.log('inputParams', JSON.stringify(inputParams))

    this.loading = true
    this.maquinaService.obtenerSegunFiltroReporteUbicacion(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
      this.paginationContext.RecordsCount = totalRegistros
      this.paginationContext.CurrentPage = paginaActual
      this.paginationContext.PagesCount = totalPaginas
      this.listaMaquinas = registros
      this.loading = false
    })
  }

  onPageChange(context: PaginationContext) {
    this.buscar(context.RequestedPage)
  }

  downloadExcelPdf(type: 'XLS' | 'PDF') {
    const inputParams = _.cloneDeep(this.currentPayload)
    delete inputParams.cantidadRegistrosPorPagina
    delete inputParams.paginaActual

    inputParams.filtro.exacto.retornaExcel = type === 'XLS'
    inputParams.filtro.exacto.retornaPDF = type === 'PDF'

    this.log('inputParams', JSON.stringify(inputParams))

    this.maquinaService.obtenerSegunFiltroReporteUbicacionExcelPdf(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo)
    })
  }

}
